import { DatePicker, Form as AntForm } from 'antd';
import styled from 'styled-components';
import { AnySchema } from 'yup';
import { Controller, Control } from 'react-hook-form';
import moment, { Moment } from 'moment';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { formHelpers } from '@helpers/formHelpers';

const { Item: FormItem } = AntForm;
const { WeekPicker } = DatePicker;

export const HSMSDatePickerField = styled(DatePicker)`
  width: 100%;
`;

export const WeekPickerField = styled(WeekPicker)`
  width: 100%;
`;

interface HSMSDatePickerProps {
  label: string;
  name: string;
  size?: SizeType;
  type?: string;
  placeholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  validationSchema?: AnySchema;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any; // If we are setting proper types we need to get the form values. Not possible since we use this in multiple forms
  defaultValue?: Moment;
}

export const HSMSDatePicker = ({
  label,
  name,
  size,
  type,
  control,
  placeholder,
  validationSchema,
  errors,
  defaultValue,
}: HSMSDatePickerProps) => (
  <FormItem
    label={label}
    required={validationSchema && formHelpers.isRequired(validationSchema, name)}
    validateStatus={errors && errors[name] ? 'error' : ''}
    help={errors && errors[name]?.message}
    labelCol={{ span: 24 }}
  >
    <Controller
      defaultValue={defaultValue}
      as={
        type === 'week' ? (
          <WeekPickerField
            size={size}
            placeholder={placeholder || 'Select a week'}
            defaultValue={moment().startOf('isoWeek')}
          />
        ) : (
          <HSMSDatePickerField placeholder={placeholder || 'YYYY-MM-DD'} size={size} />
        )
      }
      name={name}
      control={control}
    />
  </FormItem>
);
